import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { EsquemaVariable } from '../models/esquema-variable';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/EsquemaVariable';

@Injectable({
  providedIn: 'root'
})
export class EsquemaVariableService {

  constructor(private _http: HttpClientService) { }

  save(variable: any)
  {
    return this._http.post({ url: baseUrl + '/Save', body: variable });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });
  }

  getByEsquema(esquemaId: any)
  {
    return this._http.get<any>({ url: baseUrl + '/GetListByEsquema/' + esquemaId });
  }

  getDataTypes()
  {
    return this._http.get<any>({ url: baseUrl + '/GetDataTypes/' });
  }

  getTables()
  {
    return this._http.get<any>({ url: baseUrl + '/GetTables/' });
  }

  update(variable: any)
  {
    return this._http.post({ url: baseUrl + '/Update', body: variable });
  }


  getDatosDeTabla(tabla: string): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetDatosTabla/' + tabla })
  }

}
